// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__31Ble","inputWrap":"CustomTip_inputWrap__1KI-n"};